import { render, staticRenderFns } from "./OpenCardErr.vue?vue&type=template&id=ab1488f4&scoped=true&"
import script from "./OpenCardErr.vue?vue&type=script&lang=js&"
export * from "./OpenCardErr.vue?vue&type=script&lang=js&"
import style0 from "./OpenCardErr.vue?vue&type=style&index=0&id=ab1488f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1488f4",
  null
  
)

export default component.exports